
import { useState, useEffect, useRef } from "react";
import { useLocation } from "wouter";
import { Layout } from "@/components/layout";
import { useToast } from "@/hooks/use-toast";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/hooks/use-auth";

export default function CreateQuiz() {
  const [, setLocation] = useLocation();
  const { toast } = useToast();
  const { user } = useAuth();
  const [isCreating, setIsCreating] = useState(true);
  const hasStartedCreation = useRef(false);

  useEffect(() => {
    const createQuiz = async () => {
      if (hasStartedCreation.current) return;
      hasStartedCreation.current = true;

      try {
        const token = await user?.getIdToken();
        const response = await fetch("/api/quiz/create", {
          headers: {
            ...(token && { Authorization: `Bearer ${token}` })
          }
        });
        
        if (!response.ok) {
          throw new Error("Failed to create quiz");
        }
        
        const data = await response.json();
        
        // If a basic user already has a quiz, just silently redirect to it
        // No toast needed - we'll just take them to their quiz
        
        setLocation(`/quiz/${data.internalId}`);
      } catch (error: any) {
        toast({
          title: "Error",
          description: error.message || "Failed to create quiz",
          variant: "destructive",
        });
        setIsCreating(false);
        hasStartedCreation.current = false;
      }
    };

    createQuiz();
  }, [setLocation, toast, user]);

  return (
    <Layout>
      <div className="flex items-center justify-center min-h-[60vh]">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    </Layout>
  );
}
